import React from 'react'
import { Toaster } from 'react-hot-toast'
import { Provider } from 'react-redux'

import List from './features/completions/List'
import Footer from './features/completions/Footer'
import Channel from './features/completions/Channel'
import store from './store'
import PilotContext from './contexts/PilotContext'

interface Props {
  props: {
    agentKey: string
    authenticated: boolean
    context: object
    threadKey: string
  }
}

function PilotApp({ props: { agentKey, authenticated, context, threadKey } }: Props) {
  const listInnerRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    const updateListWidth = () => {
      if (listInnerRef.current) {
        const width = listInnerRef.current.offsetWidth
        document.documentElement.style.setProperty('--pilot-list-width', `${width}px`)
      }
    }

    updateListWidth()

    const resizeObserver = new ResizeObserver(updateListWidth)
    if (listInnerRef.current) {
      resizeObserver.observe(listInnerRef.current)
    }

    return () => {
      resizeObserver.disconnect()
    }
  }, [])

  return (
    <Provider store={store}>
      <PilotContext.Provider value={{ agentKey, authenticated, context, threadKey }}>
        <Toaster position='top-center' />
        <div className='pilot-window'>
          <Channel>
            <List bodyScroll={true} innerRef={listInnerRef} />
          </Channel>
          <Footer />
        </div>
      </PilotContext.Provider>
    </Provider>
  )
}

export default PilotApp
